/**
 * @generated SignedSource<<5ad82d2922b5ad354dc40a8dfd54748e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConfirmReservationInput = {
  clientMutationId?: string | null | undefined;
  reservationId: string;
};
export type OpsReservationPageConfirmMutation$variables = {
  input: ConfirmReservationInput;
};
export type OpsReservationPageConfirmMutation$data = {
  readonly confirmReservation: {
    readonly reservation: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly assetTag: any | null | undefined;
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsReservationPageConfirmMutation = {
  response: OpsReservationPageConfirmMutation$data;
  variables: OpsReservationPageConfirmMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfirmReservationPayload",
    "kind": "LinkedField",
    "name": "confirmReservation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Reservation",
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsReservationPageConfirmMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsReservationPageConfirmMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "209a07f8fc33fd25a44cb7fb95a528f5",
    "id": null,
    "metadata": {},
    "name": "OpsReservationPageConfirmMutation",
    "operationKind": "mutation",
    "text": "mutation OpsReservationPageConfirmMutation(\n  $input: ConfirmReservationInput!\n) {\n  confirmReservation(input: $input) {\n    reservation {\n      id\n    }\n    userErrors {\n      message\n      assetTag\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5743bb2af1f4e282259422f38b66c3ef";

export default node;
